export default {
    url: '/employee',
    template: `
        <courses-courses-edit-occurrence-edit-employee
            occurrence="vm.occurrence"
            can-manage-occurrences="vm.$scope.$parent.vm.canManageOccurrences"
            course="vm.course"
        />
    `,
    resolve: {
        occurrence (OccurrenceResource, $stateParams) {
            return OccurrenceResource.get({
                id: $stateParams.occurrenceId,
                expand: 'sites,courseOccurrenceParticipants,courseOccurrenceLanguages'
            }).$promise;
        }
    },
    controller ($scope, course, occurrence) {
        this.$scope = $scope;
        $scope.$parent.vm.step = 2;
        this.course = course;
        this.occurrence = occurrence;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/edit/employee/index.js